import React, {PureComponent} from 'react';

import PropTypes from 'prop-types';

class Button extends PureComponent {
  render() {
    const {id, label, onClick, className, icon, iconClassName, disabled} = this.props;
    return (
      <button
        id={id}
        onClick={onClick}
        className={className}
        disabled={disabled}
        type="button"
      >
        {icon && (
          <img
            alt={id}
            className={iconClassName}
            id={id}
            onDragStart={!disabled ? onClick : undefined}
            /* onClick = {!disabled && onClick}//double click issue */ src={icon}
            disabled={disabled}
          />
        )}
        {label && <span id={id}>{label}</span>}
      </button>
    );
  }
}
Button.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.any,
  iconClassName: PropTypes.string,
};
Button.defaultProps = {
  disabled: false,
  id: '',
  label: '',
  onClick: () => {},
  className: '',
  icon: '',
  iconClassName: '',
};
export default Button;
